// extracted by mini-css-extract-plugin
export var card = "_qk-0";
export var content = "_qk-2";
export var details = "_qk-3";
export var icon = "_qk-1";
export var iconBlue = "_qk-5";
export var iconBrand = "_qk-4";
export var iconGrayBlue = "_qk-6";
export var iconGreen = "_qk-7";
export var iconIndigo = "_qk-8";
export var iconOrange = "_qk-9";
export var iconPurple = "_qk-a";
export var iconRed = "_qk-b";
export var iconWarning = "_qk-c";